import { Link } from "react-router-dom";
import styles from "./Footer.module.css";

const EXPLORE = [
  { label: "🧁 Baking Recipes", to: "/baking" },
  { label: "💻 Dev Blog", to: "/dev" },
  { label: "⚡ Dev Hacks", to: "/hacks" },
  { label: "About Me", to: "/about" },
];

const CONNECT = [
  { label: "GitHub", href: "https://github.com" },
  { label: "LinkedIn", href: "https://linkedin.com" },
  { label: "Instagram", href: "https://instagram.com" },
];

function FooterLogo() {
  return (
    <svg
      width="180"
      height="44"
      viewBox="0 0 180 44"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Code to Crumbs"
      className={styles.logoSvg}
    >
      <circle cx="22" cy="22" r="18" fill="rgba(200,137,90,0.18)" />
      <circle
        cx="22"
        cy="22"
        r="18"
        fill="none"
        stroke="#c8895a"
        strokeWidth="1"
        opacity="0.5"
      />
      <text
        x="22"
        y="29"
        fontFamily="'Playfair Display', Georgia, serif"
        fontSize="24"
        fontWeight="700"
        fill="#f0e0cc"
        textAnchor="middle"
      >
        C
      </text>
      <circle cx="31" cy="21" r="5" fill="#c8895a" opacity="0.9" />
      <circle cx="29" cy="19" r="1.3" fill="#3d2010" opacity="0.8" />
      <circle cx="32.5" cy="23" r="1" fill="#3d2010" opacity="0.65" />
      <circle cx="30" cy="24" r="0.8" fill="#3d2010" opacity="0.55" />
      <circle cx="38" cy="12" r="1.8" fill="#c8895a" opacity="0.4" />
      <circle cx="42" cy="17" r="1.2" fill="#c8895a" opacity="0.28" />
      <line
        x1="50"
        y1="9"
        x2="50"
        y2="35"
        stroke="rgba(200,137,90,0.3)"
        strokeWidth="1"
      />
      <text
        x="58"
        y="19"
        fontFamily="'Playfair Display', Georgia, serif"
        fontSize="12.5"
        fontWeight="700"
        fill="#f0e0cc"
        letterSpacing="1.5"
      >
        CODE TO
      </text>
      <text
        x="58"
        y="33"
        fontFamily="'Playfair Display', Georgia, serif"
        fontSize="12.5"
        fontWeight="700"
        fill="#c8895a"
        letterSpacing="1.5"
      >
        CRUMBS
      </text>
      <text
        x="58"
        y="42"
        fontFamily="'DM Sans', Arial, sans-serif"
        fontSize="6.5"
        fontWeight="300"
        fill="rgba(200,137,90,0.55)"
        letterSpacing="1.8"
      >
        from coding to cookies
      </text>
    </svg>
  );
}

export default function Footer() {
  return (
    <footer className={styles.footer}>
      {/* Decorative top rule */}
      <div className={styles.topRule}>
        <span className={styles.ruleLine} />
        <span className={styles.ruleDiamond}>✦</span>
        <span className={styles.ruleLine} />
      </div>

      {/* Main 3-col grid */}
      <div className={`container ${styles.main}`}>
        {/* Col 1: Brand */}
        <div className={styles.brandCol}>
          <Link to="/" className={styles.brandLink}>
            <FooterLogo />
          </Link>
          <p className={styles.tagline}>
            A corner of the internet where clean code meets warm kitchens.
          </p>
          <p className={styles.sub}>
            Made with 🧁 + ☕ + way too many browser tabs
          </p>
          <div className={styles.socials}>
            {CONNECT.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialPill}
              >
                {s.label}
              </a>
            ))}
          </div>
        </div>

        {/* Col 2: Explore */}
        <div className={styles.linkCol}>
          <h4 className={styles.colTitle}>Explore</h4>
          {EXPLORE.map((l) => (
            <Link key={l.to} to={l.to} className={styles.link}>
              {l.label}
            </Link>
          ))}
        </div>

        {/* Col 3: CTA */}
        <div className={styles.ctaCol}>
          <h4 className={styles.colTitle}>Work with me</h4>
          <p className={styles.ctaText}>Open to freelance projects.</p>
          <Link to="/resume" className={styles.ctaBtn}>
            Hire Me ✦
          </Link>
        </div>
      </div>

      {/* Bottom bar */}
      <div className={`container ${styles.copy}`}>
        <span>
          © {new Date().getFullYear()} codetocrumbs.com · All rights reserved
        </span>
        {/* <span className={styles.copyRight}>
          Built with React ✦ Designed with care
        </span> */}
      </div>
    </footer>
  );
}
